import { API_URLS } from "@/utils/constant/api.constant";
import { C_API } from "@/utils/helper/api";
import { useQuery } from "@tanstack/react-query";

const fetchOrgDocList = async ({ perPage, page, status, query }: { perPage: number; page: number; status?: string; query?: string }): Promise<any> => {
  const params = new URLSearchParams();
  if (perPage) params.append("per_page", perPage.toString());
  if (page) params.append("page", page.toString());
  if (status) params.append("status", status);
  params.append("query", query || "");

  const response = await C_API.get(`${API_URLS.INTERNAL.DOC_LIST}?${params.toString()}`);
  return response.data?.data;
};

export const useOrgDocList = ({ perPage, page, status, query }: { perPage: number; page: number; status?: string; query?: string }) => {
  return useQuery<any, Error>({
    queryKey: ["orgDocList", perPage, page, status],
    queryFn: () => fetchOrgDocList({ perPage, page, status, query }),
    refetchInterval: 0,
    staleTime: 0,
  });
};
